import { ApiResource } from "./apiResource";
import { ApiDataResponse } from "../apiClient";
import {
  SmsType,
  SmsSituation,
  SmsScheduleType,
} from "~/pages/AppointmentPage/form/smsRule";

export interface SmsRule {
  id: number;
  title: string;
  contents: string;
  visible: boolean;
  callerNumberId: number;
  smsType: SmsType;
  smsSituation: SmsSituation;
  smsScheduleType: SmsScheduleType;
  daysOffset: number | null;
  scheduleTime: string | null;
  callerNumber: {
    id: number;
    createdAt: string;
    isDeleted: boolean;
    number: string;
    visible: boolean;
    comment: string;
  };
  imageUrl: string | null;
  departments: Array<{
    id: number;
    name: string;
    category: {
      id: number;
      name: string;
      isDeleted: boolean;
      visible: boolean;
    };
    isDeleted: boolean;
    visible: boolean;
  }>;
  treatmentItem: any | null;
  allDepartments: boolean;
  reserveCount: number;
  processStatus: string;
  inspectionStatus: string;
  failMessage: string | null;
  questionnaireTemplate: any | null;
}

export class SmsApi extends ApiResource {
  async getSmsNotifications(situations?: string) {
    return this.client.get<ApiDataResponse<SmsRule[]>>("/sms_rules", {
      params: {
        limit: 1000,
        situations: situations || "reserved",
        visible: true,
      },
    });
  }
}
